import * as React from "react";

const Form = ({ children }) => <form className="form-horizontal">{children}</form>;

export default Form;
